webpackJsonp([39],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/*!*********************************!*\
  !*** ./client/plugins/axios.js ***!
  \*********************************/
/*! exports provided: default, localAxios */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export localAxios */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(/*! axios */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var WebsiteCreateModuleShopConfig = window.WebsiteCreateModuleShopConfig || {};

/*
 * Default parameters which are added to each request
 */
var axiosParams = {};

// If we are in development mode, we add the xDebug Header to each request
if (false) {
  axiosParams = {
    XDEBUG_SESSION_START: 'PHPSTORM'
  };
}

var axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: WebsiteCreateModuleShopConfig.apiEndpoint,
  timeout: 40000,
  params: axiosParams,
  headers: {
    Authorization: 'Bearer ' + WebsiteCreateModuleShopConfig.auth.clientSecret
  }
});

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});

// ----------------------------------------
// Vue Plugin
// ----------------------------------------
var VueAxios = {
  install: function install(Vue) {
    // Globally register as $http
    Vue.prototype.$http = axios;
  }

  // ----------------------------------------
  // Install vue plugin
  // ----------------------------------------
};__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(VueAxios);

/**
 * With all the defaults for axios set, we can export it as a module.
 */
/* harmony default export */ __webpack_exports__["a"] = (axios);

/*
 * Create a local instance where the baseURL points to the backend
 */
var localAxios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: WebsiteCreateModuleShopConfig.baseURL,
  timeout: 20000
});

/***/ }),
/* 5 */,
/* 6 */
/*!***************************************!*\
  !*** ./client/plugins/wsc-locales.js ***!
  \***************************************/
/*! exports provided: usedLocale, defaultLocale, blockLocale, default */
/*! exports used: blockLocale, default, usedLocale */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return usedLocale; });
/* unused harmony export defaultLocale */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockLocale; });
var usedLocale = document.getElementsByTagName('meta')['locale_used'].getAttribute('content');
var defaultLocale = document.getElementsByTagName('meta')['locale_default'].getAttribute('content');
var blockLocale = document.getElementsByTagName('meta')['blocklocale_used'].getAttribute('content');

/* harmony default export */ __webpack_exports__["b"] = ({
  usedLocale: usedLocale,
  defaultLocale: defaultLocale,
  blockLocale: blockLocale
});

/***/ }),
/* 7 */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_cartStorage__ = __webpack_require__(/*! ./plugins/cartStorage */ 23);
/*
 * This is the entry point for the store.
 * Create a new module for your store object
 */




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var files = __webpack_require__(/*! ./ */ 108);
var filenames = files.keys();

function getModule(filename) {
  var file = files(filename);
  return file.default ? file.default : file;
}

function getModuleNamespace(storeData, namePath) {
  if (namePath.length === 1) return storeData.modules;

  var namespace = namePath.shift();

  storeData.modules[namespace] = storeData.modules[namespace] || {};
  storeData.modules[namespace].namespaced = true;
  storeData.modules[namespace].modules = storeData.modules[namespace].modules || {};

  return getModuleNamespace(storeData.modules[namespace], namePath);
}

var store = void 0;
var storeData = {};

// Generate the store from all the modules inside the store folder
storeData.modules = storeData.modules || {};
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = filenames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var filename = _step.value;

    var name = filename.replace(/^\.\//, '').replace(/\.js$/, '');
    if (name === 'index') continue;

    var namePath = name.split(/\//);
    var module = getModuleNamespace(storeData, namePath);

    name = namePath.pop();
    module[name] = getModule(filename);
    module[name].namespaced = true;
  }

  // Plugins
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

storeData.plugins = storeData.plugins || [];
storeData.plugins.push(Object(__WEBPACK_IMPORTED_MODULE_2__plugins_cartStorage__["default"])());

store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(storeData);

/* harmony default export */ __webpack_exports__["default"] = (store);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/*!**********************************!*\
  !*** ./client/router/_helper.js ***!
  \**********************************/
/*! exports provided: componentsHelper */
/*! exports used: componentsHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentsHelper; });
var componentsHelper = function componentsHelper(path) {
  return {
    name: path,
    components: {
      desktop: function desktop() {
        return __webpack_require__(/*! ../views/desktop */ 187)("./" + path);
      },
      mobile: function mobile() {
        return __webpack_require__(/*! ../views/mobile */ 190)("./" + path);
      }
    }
  };
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/*!************************************!*\
  !*** ./client/plugins/vue-i18n.js ***!
  \************************************/
/*! exports provided: fetchLocale, default */
/*! exports used: default, fetchLocale */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(/*! vue-i18n */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_messageformat__ = __webpack_require__(/*! messageformat */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_formaters_price__ = __webpack_require__(/*! ./i18n-formaters/price */ 106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wsc_locales__ = __webpack_require__(/*! ./wsc-locales */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(/*! axios */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var loadLanguageAsync = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(locale) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/userdata/translations/' + locale + '.json', { responseType: 'json' });

          case 2:
            data = _context.sent;


            i18n.setLocaleMessage(locale, data.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loadLanguageAsync(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var MessageFormatter = function () {
  function MessageFormatter(options) {
    _classCallCheck(this, MessageFormatter);

    this._locale = options.locale || 'en-US';
    this._formatter = new __WEBPACK_IMPORTED_MODULE_3_messageformat___default.a(this._locale);
    this._caches = Object.create(null);

    this._formatter.addFormatters({
      // momentAgo (value) { return moment(value).fromNow() }
      price: __WEBPACK_IMPORTED_MODULE_4__i18n_formaters_price__["a" /* default */]
    });
  }

  _createClass(MessageFormatter, [{
    key: 'interpolate',
    value: function interpolate(message, values) {
      var fn = this._caches[message];
      if (!fn) {
        fn = this._formatter.compile(message, this._locale);
        this._caches[message] = fn;
      }
      return [fn(values)];
    }
  }]);

  return MessageFormatter;
}();

var formatter = new MessageFormatter({ locale: __WEBPACK_IMPORTED_MODULE_5__wsc_locales__["a" /* blockLocale */] });

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_5__wsc_locales__["a" /* blockLocale */],
  formatter: formatter
});

var fetchLocale = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadLanguageAsync(__WEBPACK_IMPORTED_MODULE_5__wsc_locales__["a" /* blockLocale */]);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchLocale() {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 23 */
/*!*********************************************!*\
  !*** ./client/store/plugins/cartStorage.js ***!
  \*********************************************/
/*! exports provided: default, initializeCart */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = cartStorage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initializeCart", function() { return initializeCart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(/*! localforage */ 107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);


var _this2 = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var localstorageCartKey = 'v1_shop_cart';
var isInternalUpdate = false;

var updateStoreFromStrorage = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(store) {
    var storeCartState;
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem(localstorageCartKey);

          case 2:
            storeCartState = _context.sent;


            store.commit('cart/initialize');

            if (!(!storeCartState || storeCartState.expires < new Date())) {
              _context.next = 7;
              break;
            }

            // if there is no cart saved in storage, or the saved state is expired,
            // clear the cart
            store.commit('cart/clear');
            return _context.abrupt('return');

          case 7:

            isInternalUpdate = true;
            _context.next = 10;
            return store.dispatch('cart/initialize', storeCartState.value);

          case 10:
            isInternalUpdate = false;

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function updateStoreFromStrorage(_x) {
    return _ref.apply(this, arguments);
  };
}();

function cartStorage() {
  var _this = this;

  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(store) {
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // subscribe for changes in the store
              store.subscribe(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(mutation, state) {
                  var storeCartState, storeExipresAt;
                  return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!isInternalUpdate) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt('return');

                        case 2:
                          if (!(!mutation.type.includes('cart') || mutation.type === 'cart/initialize')) {
                            _context2.next = 4;
                            break;
                          }

                          return _context2.abrupt('return');

                        case 4:
                          storeCartState = JSON.parse(JSON.stringify(state.cart));

                          // Storage expires in 5 days

                          storeExipresAt = new Date();

                          storeExipresAt.setDate(storeExipresAt.getDate() + 5);

                          _context2.next = 9;
                          return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem(localstorageCartKey, {
                            value: storeCartState,
                            expires: storeExipresAt
                          });

                        case 9:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this);
                }));

                return function (_x3, _x4) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

// initialize the store with the state from the storage
var initializeCart = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(store) {
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', updateStoreFromStrorage(store));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this2);
  }));

  return function initializeCart(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/App.vue ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plugins_vue_i18n__ = __webpack_require__(/*! plugins/vue-i18n */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_plugins_cartStorage__ = __webpack_require__(/*! ./store/plugins/cartStorage */ 23);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_2_plugins_vue_i18n__["b" /* fetchLocale */])();

            case 2:
              this.localesLoaded = true;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.requestShop();
              this.requestShopInformation();
              _context2.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_3__store_plugins_cartStorage__["initializeCart"])(this.$store);

            case 4:
              this.registerNavigationIEFix();

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  data: function data() {
    return {
      mediaQueryDevice: 'mobile',
      localesLoaded: false
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    useRootContainer: 'shop/getUseRootContainer',
    isMobile: 'shop/getMetaIsMobile'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 961;
    var RATIO = 0;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        // on fast resizes shop-content gets loaded twice due to async loading of components. Here we delete duplicates:
        document.querySelectorAll('.wc_element_modules__shop').forEach(function (el, i) {
          if (i > 0) el.remove();
        });
        _this.mediaQueryDevice = isMobile ? 'mobile' : 'desktop';
        _this.setMetaIsMobile(isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    handler();

    this.setMetaIsEditor(this.inIframe());
  },

  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setMetaIsMobile: 'shop/setMetaIsMobile',
    setMetaIsEditor: 'shop/setMetaIsEditor'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    requestShop: 'shop/request',
    requestShopInformation: 'shopInformation/request',
    requestProducts: 'products/request'
  }), {
    inIframe: function inIframe() {
      // test if we are inside a frame / in the editor
      // since window.top might not be defined or blocked due to same-origin policy,
      // we need to catch errors
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    registerNavigationIEFix: function registerNavigationIEFix() {
      var _this2 = this;

      // Fix for IE, routing does not work in IE if elements are outside of vue application.
      // So we need to add an event to each link and trigger navigation manually
      var elements = document.getElementsByClassName('navigationElement shop');
      Array.prototype.forEach.call(elements, function (el) {
        var nodes = el.getElementsByTagName('A');
        if (nodes.length) {
          Array.prototype.forEach.call(nodes, function (node) {
            node.addEventListener('click', _this2.navigate);
          });
        }
      });
    },
    navigate: function navigate(event) {
      var url = '';
      if (event.target.hash) {
        url = event.target.hash.replace('#', '');
      } else {
        url = event.target.parentNode.hash.replace('#', '');
      }
      this.$router.push(url);
    }
  })
});

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/*!********************************************!*\
  !*** ./client/plugins/wsc-translatable.js ***!
  \********************************************/
/*! exports provided: translatable, translatableOrDefault */
/*! exports used: translatable, translatableOrDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = translatable;
/* harmony export (immutable) */ __webpack_exports__["b"] = translatableOrDefault;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wsc_locales__ = __webpack_require__(/*! ./wsc-locales */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(/*! lodash/get */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);



/**
 * @param model
 * @param prop
 * @param locale
 * @returns {null}
 */
function translatable(model, prop) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(model, ['translatable', getLocale(locale), prop]);
}

/**
 * @param model
 * @param prop
 * @param locale
 * @returns {null}
 */
function translatableOrDefault(model, prop) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return translatable(model, prop, locale) || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(model, ['translatable', getDefaultLocale(), prop]);
}

/**
 * @param locale
 * @returns string
 */
function getLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  return locale || __WEBPACK_IMPORTED_MODULE_0__wsc_locales__["b" /* default */].usedLocale;
}

/**
 * @param locale
 * @returns string
 */
function getDefaultLocale() {
  return __WEBPACK_IMPORTED_MODULE_0__wsc_locales__["b" /* default */].defaultLocale;
}

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/*!************************************!*\
  !*** ./client/plugins/wsc-shop.js ***!
  \************************************/
/*! exports provided: supportedCurrencies, supportedWeight, default */
/*! exports used: supportedCurrencies */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedCurrencies; });
/* unused harmony export supportedWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(/*! ./../store/index */ 7);



var supportedCurrencies = [{
  label: 'Schweizer Franken - CHF',
  short: 'CHF',
  value: 'chf',
  local: 'de-ch'
}, {
  label: 'Euro - EUR (€)',
  short: '€',
  value: 'eur',
  local: 'de-de'
}, {
  label: 'US-Dollar - USD ($)',
  short: '$',
  value: 'usd',
  local: 'en-us'
}, {
  label: 'Pfund Sterling - GBP (£)',
  short: '£',
  value: 'gbp',
  local: 'en-gb'
}];

var supportedWeight = [{
  label: 'Kilogramm (kg)',
  short: 'kg',
  value: 'kg'
}, {
  label: 'Gramm (g)',
  short: 'g',
  value: 'g'
}];

var emptyStub = {
  label: '',
  short: '',
  value: ''

  /*
   * Vue plugin
   */
};var MyPlugin = {
  install: function install(Vue, options) {
    Vue.prototype.$supportedCurrencies = supportedCurrencies;

    Vue.prototype.$supportedWeight = supportedWeight;

    Vue.mixin({
      computed: {
        shop: function shop() {
          return __WEBPACK_IMPORTED_MODULE_1__store_index__["default"].getters['shop/get'];
        },
        shopCurrency: function shopCurrency() {
          var _this = this;

          var shopCurrency = supportedCurrencies.find(function (option) {
            return option.value === _this.shop.currency;
          });
          if (shopCurrency === undefined) return emptyStub;
          return shopCurrency;
        },
        shopWeight: function shopWeight() {
          var _this2 = this;

          var shopWeight = supportedWeight.find(function (option) {
            return option.value === _this2.shop.weight;
          });
          if (shopWeight === undefined) return emptyStub;
          return shopWeight;
        }
      }
    });
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(MyPlugin);

/* unused harmony default export */ var _unused_webpack_default_export = (MyPlugin);

/***/ }),
/* 43 */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guards_beforeEach__ = __webpack_require__(/*! ./guards/beforeEach */ 183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guards_afterEach__ = __webpack_require__(/*! ./guards/afterEach */ 184);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var files = __webpack_require__(/*! ./ */ 185);
var filenames = files.keys();

function getRoutes(filename) {
  var file = files(filename);
  return file.default ? file.default : file;
}

var routes = [];
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = filenames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var filename = _step.value;

    var name = filename.replace(/^\.\//, '').replace(/\.js$/, '');
    if (name === 'index') continue;

    var namePath = name.split(/\//);
    name = namePath.pop();
    routes.push.apply(routes, _toConsumableArray(getRoutes(filename)));
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/products'
  }].concat(routes)
});

router.beforeEach(__WEBPACK_IMPORTED_MODULE_2__guards_beforeEach__["a" /* default */]);
router.afterEach(__WEBPACK_IMPORTED_MODULE_3__guards_afterEach__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),
/* 44 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/slider.vue ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    toggleChecked: function toggleChecked() {
      if (this.disabled) return;

      this.$emit('input', !this.value);
    },

    updateInput: function updateInput(event) {
      this.$emit('input', event.target.checked);
    }
  }
});

/***/ }),
/* 45 */
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/loading.vue ***!
  \****************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      default: true
    }
  }
});

/***/ }),
/* 46 */
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/multiselect.vue ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(/*! vue-multiselect */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  props: ['value', 'label', 'customLabel', 'track-by', 'options', 'multiple', 'taggable', 'allow-empty', 'close-on-select', 'clear-on-select', 'disabled', 'placeholder'],
  computed: {
    placeholderText: function placeholderText() {
      if (this.value && this.value.length !== 0) return '';
      return this.placeholder || '';
    }
  },
  methods: {
    tag: function tag() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['tag'].concat(_toConsumableArray(args)));
    },
    input: function input() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['input'].concat(_toConsumableArray(args)));
    }
  }
});

/***/ }),
/* 47 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/singleselect.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    classes: {},
    placeholder: {},
    value: {
      default: undefined
    }
  },
  computed: {},
  methods: {
    valueChanged: function valueChanged(event) {
      this.$emit('input', event.target.value);
    }
  }
});

/***/ }),
/* 48 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/productPanel.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 13);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDetail: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])({
    shop: 'shop/get',
    isMobile: 'shop/getMetaIsMobile'
  }), {
    usePanels: function usePanels() {
      if (this.$route.params.id) return this.usePanelsDetail;
      return this.usePanelsOverview;
    },
    usePanelsOverview: function usePanelsOverview() {
      if (this.isMobile) return this.$_get(this.shop, ['display', 'mobile', 'overview', 'use_panels']);
      return this.$_get(this.shop, ['display', 'desktop', 'overview', 'use_panels']);
    },
    usePanelsDetail: function usePanelsDetail() {
      if (this.isMobile) return this.$_get(this.shop, ['display', 'mobile', 'detail', 'use_panels']);
      return this.$_get(this.shop, ['display', 'desktop', 'detail', 'use_panels']);
    }
  })
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 88);



// Without a timeout, jquery can cause a race condition where it moves the element
// in the exact same frame where the application initializes. This will result in
// 2 application instances.
setTimeout(function () {
  __WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#wsc_shop_app');
}, 2);

/***/ }),
/* 85 */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

// Polyfill for NodeList in IE11
NodeList.prototype.forEach = NodeList.prototype.forEach || Array.prototype.forEach;

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/*! exports provided: app, router, store */
/*! exports used: app */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(/*! ./App.vue */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! ./store */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plugins__ = __webpack_require__(/*! plugins */ 194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_plugins_vue_i18n__ = __webpack_require__(/*! plugins/vue-i18n */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_scss_style_scss__ = __webpack_require__(/*! ../assets/scss/style.scss */ 215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_scss_style_scss__);
/* unused harmony reexport router */
/* unused harmony reexport store */






// Import all plugins


// vue-i18n needs to be passed to the vue Application, so we will import is here


// Global styling for the shop


Object(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["default"], __WEBPACK_IMPORTED_MODULE_3__router__["default"]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["default"],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["default"],
  i18n: __WEBPACK_IMPORTED_MODULE_6_plugins_vue_i18n__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]));



/***/ }),
/* 89 */,
/* 90 */
/*!************************!*\
  !*** ./client/App.vue ***!
  \************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672d7c5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-672d7c5a","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 181);
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672d7c5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/*!************************************************!*\
  !*** ./client/plugins/i18n-formaters/price.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(/*! store */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_wsc_shop__ = __webpack_require__(/*! plugins/wsc-shop */ 42);



var price = function price(value) {
  if (!__WEBPACK_IMPORTED_MODULE_0_store__["default"].state.shop.shop) return '';

  var shopCurrency = __WEBPACK_IMPORTED_MODULE_1_plugins_wsc_shop__["a" /* supportedCurrencies */].find(function (option) {
    return option.value === __WEBPACK_IMPORTED_MODULE_0_store__["default"].state.shop.shop.currency;
  });

  // divide the value by 100 to convert from cent to currency
  var formatedPrice = (value / 100).toLocaleString(shopCurrency.local, {
    minimumFractionDigits: 2
  });

  if (shopCurrency) {
    return shopCurrency.short + ' ' + formatedPrice;
  }
  return formatedPrice;
};

/* harmony default export */ __webpack_exports__["a"] = (price);

/***/ }),
/* 107 */,
/* 108 */
/*!***********************************!*\
  !*** ./client/store ^\.\/.*\.js$ ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart.js": 109,
	"./categories.js": 128,
	"./index.js": 7,
	"./options.js": 129,
	"./order.js": 130,
	"./paymentMethods.js": 131,
	"./plugins/cartStorage.js": 23,
	"./products.js": 132,
	"./shop.js": 179,
	"./shopInformation.js": 180
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;

/***/ }),
/* 109 */
/*!******************************!*\
  !*** ./client/store/cart.js ***!
  \******************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep__ = __webpack_require__(/*! lodash.clonedeep */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var state = {
  list: null,
  initialize: false,
  differentDeliveryCustomer: false,
  paymentCustomer: {},
  deliveryCustomer: {},
  shippingRegulations: null,
  checkoutFormSettings: null
};

var getters = {
  cart: function cart(state) {
    return state.list;
  },
  countArticles: function countArticles(state) {
    // If the cart has not been initialized return null
    if (!state.list) return null;
    return state.list.length;
  },
  cartTotalPrice: function cartTotalPrice(state, getters, rootState, rootGetters) {
    // If the cart has not been initialized return null
    if (!state.list) return null;
    // Map over all Articles and get their price
    var prices = state.list.map(function (article) {
      var product = rootGetters['products/getProductById'](article.product_id);
      // If the article is not a variation return the default price
      if (!article.variation_id) {
        if (product.use_discount_price) {
          return product.default_discount_price * article.amount;
        }
        return product.default_price * article.amount;
      }

      // otherwise return the price of the variation
      var variation = rootGetters['products/getVariationForProduct'](article.product_id, article.variation_id);
      if (!variation) return 0;
      if (product.use_discount_price) {
        return variation.discount_price * article.amount;
      }
      return variation.price * article.amount;
    });

    return prices.reduce(function (sum, price) {
      return sum + price;
    }, 0);
  },
  differentDeliveryCustomer: function differentDeliveryCustomer(state) {
    return state.differentDeliveryCustomer;
  },
  paymentCustomer: function paymentCustomer(state) {
    return state.paymentCustomer;
  },
  deliveryCustomer: function deliveryCustomer(state) {
    if (!state.differentDeliveryCustomer) {
      return state.paymentCustomer;
    }
    return state.deliveryCustomer;
  }
};

var mutations = {
  initialize: function initialize(state) {
    state.initialize = true;
  },
  add: function add(state, article) {
    if (state.initialize) {
      state.list = [];
      state.initialize = false;
    }

    var existingArticle = state.list.find(function (c) {
      return c.product_id === article.product_id && c.variation_id === article.variation_id;
    });

    if (existingArticle) {
      existingArticle.amount += article.amount;
      return existingArticle.amount;
    }

    return state.list.push({
      product_id: article.product_id,
      variation_id: article.variation_id,
      amount: article.amount
    });
  },
  update: function update(state, article) {
    state.list.splice(state.list.findIndex(function (c) {
      return c.product_id === article.product_id && c.variation_id === article.variation_id;
    }), 1, article);
  },
  remove: function remove(state, article) {
    state.list.splice(state.list.indexOf(article), 1);
  },
  clear: function clear(state) {
    state.list = [];
  },
  setDifferentDeliveryCustomer: function setDifferentDeliveryCustomer(state, differentDeliveryCustomer) {
    state.differentDeliveryCustomer = differentDeliveryCustomer;
  },
  setPaymentCustomer: function setPaymentCustomer(state, paymentCustomer) {
    state.paymentCustomer = paymentCustomer;
  },
  setDeliveryCustomer: function setDeliveryCustomer(state, deliveryCustomer) {
    state.deliveryCustomer = deliveryCustomer;
  }
};

var actions = {
  initialize: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, value) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit;

      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, article;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.differentDeliveryCustomer = value.differentDeliveryCustomer;
              state.paymentCustomer = value.paymentCustomer;
              state.deliveryCustomer = value.deliveryCustomer;

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 6;
              _iterator = value.list[Symbol.iterator]();

            case 8:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 15;
                break;
              }

              article = _step.value;
              _context.next = 12;
              return dispatch('addArticle', article);

            case 12:
              _iteratorNormalCompletion = true;
              _context.next = 8;
              break;

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 21:
              _context.prev = 21;
              _context.prev = 22;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 24:
              _context.prev = 24;

              if (!_didIteratorError) {
                _context.next = 27;
                break;
              }

              throw _iteratorError;

            case 27:
              return _context.finish(24);

            case 28:
              return _context.finish(21);

            case 29:
              if (state.list) {
                _context.next = 32;
                break;
              }

              _context.next = 32;
              return commit('clear');

            case 32:
              return _context.abrupt('return', state);

            case 33:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 17, 21, 29], [22,, 24, 28]]);
    }));

    function initialize(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return initialize;
  }(),
  addArticle: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, article) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch('products/requestDetailed', article.product_id, { root: true });

            case 2:
              _context2.next = 4;
              return commit('add', article);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function addArticle(_x3, _x4) {
      return _ref4.apply(this, arguments);
    }

    return addArticle;
  }(),
  updateArticle: function updateArticle(_ref5, article) {
    var state = _ref5.state,
        commit = _ref5.commit;

    commit('update', article);
  },
  removeArticle: function removeArticle(_ref6, article) {
    var state = _ref6.state,
        commit = _ref6.commit;

    commit('remove', article);
  },
  getDeliveryCountries: function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7) {
      var state = _ref7.state,
          commit = _ref7.commit,
          getters = _ref7.getters,
          rootGetters = _ref7.rootGetters;

      var _ref9, data, shippingRegulations, useWeight, _ref10, _data, availableOptions;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (state.shippingRegulations) {
                _context3.next = 6;
                break;
              }

              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shipping-regulations');

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data;

              state.shippingRegulations = data.data;

            case 6:
              shippingRegulations = state.shippingRegulations;

              // only active regulations

              shippingRegulations = shippingRegulations.filter(function (regulation) {
                return regulation.active;
              });

              // otherwise it doesn't get correct value and causes wrong behaviour with country select
              useWeight = rootGetters['shop/get'].use_weight;

              if (!(useWeight === undefined)) {
                _context3.next = 15;
                break;
              }

              _context3.next = 12;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('shops');

            case 12:
              _ref10 = _context3.sent;
              _data = _ref10.data;

              useWeight = _data.data.use_weight;

            case 15:

              // if system wide no weight - only options where the delivery_type is not "weight"
              if (!useWeight) {
                shippingRegulations = shippingRegulations.filter(function (regulation) {
                  regulation.options = regulation.options.filter(function (option) {
                    return option.delivery_type !== 'weight';
                  });
                  return regulation.options.length > 0;
                });
              }

              availableOptions = shippingRegulations.map(function (option) {
                return option.countries;
              }).reduce(function (a, b) {
                return a.concat(b);
              }, []);
              return _context3.abrupt('return', availableOptions);

            case 18:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getDeliveryCountries(_x5) {
      return _ref8.apply(this, arguments);
    }

    return getDeliveryCountries;
  }(),
  getDeliveryOptions: function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref11) {
      var state = _ref11.state,
          commit = _ref11.commit,
          getters = _ref11.getters,
          rootGetters = _ref11.rootGetters;

      var _ref13, data, deliveryCustomer, availableOptions, newvar, copy;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (state.shippingRegulations) {
                _context4.next = 6;
                break;
              }

              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shipping-regulations');

            case 3:
              _ref13 = _context4.sent;
              data = _ref13.data;

              state.shippingRegulations = data.data;

            case 6:
              deliveryCustomer = getters.deliveryCustomer;

              // only options with the same country

              availableOptions = state.shippingRegulations.filter(function (option) {
                return option.active && option.countries.includes(deliveryCustomer.country);
              });
              newvar = availableOptions;

              // if system wide no weight - only options where the delivery_type is not "weight"

              if (!rootGetters['shop/get'].use_weight) {
                copy = __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep___default()(availableOptions);

                newvar = copy.filter(function (regulation) {
                  regulation.options = regulation.options.filter(function (option) {
                    return option.delivery_type !== 'weight';
                  });
                  return regulation.options.length > 0;
                });
              }

              return _context4.abrupt('return', newvar);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getDeliveryOptions(_x6) {
      return _ref12.apply(this, arguments);
    }

    return getDeliveryOptions;
  }(),
  getCheckoutFormSettings: function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(_ref14) {
      var state = _ref14.state,
          commit = _ref14.commit,
          getters = _ref14.getters,
          rootGetters = _ref14.rootGetters;

      var _ref16, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (state.checkoutFormSettings) {
                _context5.next = 6;
                break;
              }

              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/checkout-form');

            case 3:
              _ref16 = _context5.sent;
              data = _ref16.data;

              state.checkoutFormSettings = data.data;

            case 6:
              return _context5.abrupt('return', state.checkoutFormSettings);

            case 7:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getCheckoutFormSettings(_x7) {
      return _ref15.apply(this, arguments);
    }

    return getCheckoutFormSettings;
  }()
};

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/*!************************************!*\
  !*** ./client/store/categories.js ***!
  \************************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  list: []
};

var getters = {
  categories: function categories(state) {
    return state.list;
  },
  countCategories: function countCategories(state) {
    return state.list.length;
  },

  getCategoryById: function getCategoryById(state, getters) {
    return function (id) {
      if (state.list.length === 0) return null;
      return state.list.find(function (category) {
        return category.id === id;
      });
    };
  }
};

var mutations = {
  add: function add(state, category) {
    var oldCategory = state.list.find(function (c) {
      return c.id === category.id;
    });

    if (oldCategory) {
      return state.list.splice(state.list.indexOf(oldCategory), 1, category);
    }

    return state.list.push(category);
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, forceRequest) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!forceRequest && state.list.length)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/categories');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              data.data.forEach(function (category) {
                return commit('add', category);
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 129 */
/*!*********************************!*\
  !*** ./client/store/options.js ***!
  \*********************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  list: []
};

var getters = {
  options: function options(state) {
    return state.list;
  },
  optionValues: function optionValues(state) {
    var optionValues = [];
    state.list.forEach(function (option) {
      option.values.forEach(function (value) {
        if (!optionValues.find(function (ov) {
          return ov.id === value.id;
        })) {
          optionValues.push(value);
        }
      });
    });
    return optionValues;
  },

  getOptionByOptionId: function getOptionByOptionId(state) {
    return function (id) {
      if (state.list.length === 0) return null;
      return state.list.filter(function (option) {
        return option.id === id;
      });
    };
  },
  getOptionByOptionValueId: function getOptionByOptionValueId(state) {
    return function (oVId) {
      var optionValues = getters.optionValues(state);
      var optionValue = optionValues.find(function (value) {
        return value.id === oVId;
      });
      if (!optionValue) {
        return null;
      }
      return state.list.find(function (o) {
        return o.id === optionValue.option_id;
      });
    };
  },
  getOptionValueByOptionValueId: function getOptionValueByOptionValueId(state, getters) {
    return function (oVId) {
      var optionValues = getters.optionValues;
      if (optionValues.length === 0) return null;
      return optionValues.find(function (value) {
        return value.id === oVId;
      });
    };
  }
};

var mutations = {
  add: function add(state, option) {
    var oldOption = state.list.find(function (c) {
      return c.id === option.id;
    });

    if (oldOption) {
      return state.list.splice(state.list.indexOf(oldOption), 1, option);
    }

    return state.list.push(option);
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, forceRequest) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!forceRequest && state.list.length)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/options');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              data.data.forEach(function (option) {
                return commit('add', option);
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 130 */
/*!*******************************!*\
  !*** ./client/store/order.js ***!
  \*******************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plugins_wsc_locales__ = __webpack_require__(/*! plugins/wsc-locales */ 6);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var state = {
  order: null
};

var getters = {
  order: function order(state) {
    return state.order;
  }
};

var mutations = {
  set: function set(state, order) {
    state.order = order;
  },
  clearOrder: function clearOrder(state) {
    state.order = null;
  }
};

var actions = {
  create: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, order) {
      var state = _ref.state,
          commit = _ref.commit,
          getters = _ref.getters;
      var response;
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (getters.order) {
                order = Object.assign({}, getters.order, order);
              }

              // add locale key
              order.locale_key = __WEBPACK_IMPORTED_MODULE_2_plugins_wsc_locales__["b" /* default */].usedLocale;

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].post('/orders', order);

            case 4:
              response = _context.sent;
              _context.next = 7;
              return commit('set', response.data.data);

            case 7:
              return _context.abrupt('return', response.data.data);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return create;
  }(),
  monitor: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, orderId) {
      var state = _ref3.state,
          commit = _ref3.commit,
          getters = _ref3.getters;
      var response;
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/orders/' + orderId + '/monitor?id=' + Math.random() * 10);

            case 2:
              response = _context2.sent;
              _context2.next = 5;
              return commit('set', response.data.data);

            case 5:
              return _context2.abrupt('return', response.data.data);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function monitor(_x3, _x4) {
      return _ref4.apply(this, arguments);
    }

    return monitor;
  }(),
  cancel: function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, _ref6) {
      var state = _ref5.state,
          commit = _ref5.commit,
          getters = _ref5.getters;
      var order = _ref6.order,
          payment = _ref6.payment;
      var request, response;
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              request = { order: order, payment: payment };
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].post('/payment-processors/cancel?id=' + Math.random() * 10, request);

            case 3:
              response = _context3.sent;
              return _context3.abrupt('return', response.data.data);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function cancel(_x5, _x6) {
      return _ref7.apply(this, arguments);
    }

    return cancel;
  }()
};

/***/ }),
/* 131 */
/*!****************************************!*\
  !*** ./client/store/paymentMethods.js ***!
  \****************************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  list: null
};

var getters = {
  get: function get(state) {
    if (!state.list) return {};
    return state.list;
  }
};

var mutations = {
  set: function set(state, paymentMethods) {
    state.list = paymentMethods;
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.list) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shops/payment-methods?id=' + Math.random() * 10);

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              commit('set', data.data);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 132 */
/*!**********************************!*\
  !*** ./client/store/products.js ***!
  \**********************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(/*! lodash.filter */ 133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderby__ = __webpack_require__(/*! lodash.orderby */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_orderby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_search__ = __webpack_require__(/*! mixins/search */ 134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plugins_wsc_locales__ = __webpack_require__(/*! plugins/wsc-locales */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_wsc_translatable__ = __webpack_require__(/*! ../plugins/wsc-translatable */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(/*! lodash/get */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_wsc_locales__ = __webpack_require__(/*! ../plugins/wsc-locales */ 6);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










var state = {
  list: [],
  filteredList: [],
  count: 0,
  completeListRequested: false,
  filter: {
    name: '',
    category: null
  },
  order: [{
    direction: 'desc',
    field: 'created_at'
  }],
  page: 1,
  pageCount: 0
};

var getters = {
  products: function products(state) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(state.list, function (product) {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(product, ['translatable', __WEBPACK_IMPORTED_MODULE_5_plugins_wsc_locales__["b" /* default */].usedLocale, 'visible'], false);
    });
  },
  filteredProducts: function filteredProducts(state, getters) {
    var products = getters.products;

    // filter products by category
    if (state.filter.category) {
      products = products.filter(function (product) {
        return product.categories.includes(state.filter.category);
      });
    }

    // filter products by searchstring
    if (state.filter.name.length > 0) {
      products = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(products, function (product) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_mixins_search__["a" /* default */])(state.filter.name, [Object(__WEBPACK_IMPORTED_MODULE_6__plugins_wsc_translatable__["b" /* translatableOrDefault */])(product, 'name')]);
      });
    }

    // create a new virtual property that contains the price for sorting
    products = products.map(function (p) {
      return Object.assign({}, p, {
        sorting_name: Object(__WEBPACK_IMPORTED_MODULE_6__plugins_wsc_translatable__["b" /* translatableOrDefault */])(p, 'name'),
        sorting_price: p.use_discount_price ? p.default_discount_price : p.default_price
      });
    });

    var order = state.order || [];
    return __WEBPACK_IMPORTED_MODULE_2_lodash_orderby___default()(products, order.map(function (item) {
      return item.field;
    }), order.map(function (item) {
      return item.direction;
    }));
  },
  requestedProducts: function requestedProducts(state) {
    return state.filteredList;
  },
  countProducts: function countProducts(state) {
    return state.list.length;
  },
  countFilteredProducts: function countFilteredProducts(state, getters) {
    return state.count;
  },
  allSelected: function allSelected(state) {
    if (!state.list.length) return false;
    return state.list.reduce(function (acc, product) {
      return acc && product.isSelected;
    }, true);
  },
  hasSelected: function hasSelected(state) {
    if (!state.list.length) return false;
    return state.list.reduce(function (acc, product) {
      return acc || product.isSelected;
    }, false);
  },
  filterName: function filterName(state) {
    return state.filter.name;
  },
  filterCategory: function filterCategory(state) {
    return state.filter.category;
  },
  order: function order(state) {
    return state.order ? state.order[0] : null;
  },
  page: function page(state) {
    return state.page;
  },
  countPages: function countPages(state) {
    return state.pageCount;
  },

  getProductById: function getProductById(state, getters) {
    return function (id) {
      if (state.list.length === 0) return null;
      return state.list.find(function (product) {
        return product.id === id;
      });
    };
  },
  getVariationForProduct: function getVariationForProduct(state, getters) {
    return function (productId, variationId) {
      var product = getters.getProductById(productId);
      if (!product || !product.variations) return null;

      return product.variations.find(function (variation) {
        return variation.id === variationId;
      });
    };
  },
  getProductsOfCategory: function getProductsOfCategory(state) {
    return function (_ref) {
      var id = _ref.id;

      return state.list.filter(function (product) {
        return product.categories.includes(id);
      });
    };
  }
};

var mutations = {
  add: function add(state, product) {
    var oldProduct = state.list.find(function (p) {
      return p.id === product.id;
    });

    if (oldProduct) {
      if (product.images[0] && oldProduct.images[0]) {
        product.images[0].thumbnails = Object.assign({}, oldProduct.images[0].thumbnails, product.images[0].thumbnails);
      }

      return state.list.splice(state.list.indexOf(oldProduct), 1, Object.assign({}, oldProduct, product));
    }

    return state.list.push(Object.assign({}, product, {
      isSelected: false
    }));
  },
  replace: function replace(state, product) {
    var oldProduct = state.list.find(function (p) {
      return p.id === product.id;
    });

    state.list.splice(state.list.indexOf(oldProduct), 1, Object.assign({}, product, oldProduct, {
      isSelected: oldProduct.isSelected
    }));
  },
  setFilterName: function setFilterName(state, search) {
    state.filter.name = search;
  },
  setFilterCategory: function setFilterCategory(state, category) {
    state.filter.category = category || undefined;
  },
  setOrder: function setOrder(state, order) {
    state.order = [order];
  },
  setPage: function setPage(state, page) {
    state.page = page;
  },
  refreshStock: function refreshStock(state, stockUpdateObject) {
    var oldProduct = state.list.find(function (p) {
      return p.id === stockUpdateObject.id;
    });

    oldProduct.stock = stockUpdateObject.stock;
    oldProduct.use_stock = stockUpdateObject.use_stock;
  }
};

var actions = {
  request: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      var _ref4, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.completeListRequested) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].get('/products');

            case 4:
              _ref4 = _context.sent;
              data = _ref4.data;

              data.data.forEach(function (product) {
                return commit('add', product);
              });

              state.completeListRequested = true;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x) {
      return _ref3.apply(this, arguments);
    }

    return request;
  }(),
  requestFiltered: function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, device) {
      var state = _ref5.state,
          commit = _ref5.commit,
          getters = _ref5.getters;

      var request, _ref7, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              request = {
                page: getters.page,
                category: getters.filterCategory,
                order: {
                  direction: getters.order.direction,
                  field: getters.order.field
                },
                search: getters.filterName,
                device: device,
                locale: __WEBPACK_IMPORTED_MODULE_8__plugins_wsc_locales__["c" /* usedLocale */]
              };
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].post('/products/filtered?id=' + Math.random(), request);

            case 3:
              _ref7 = _context2.sent;
              data = _ref7.data;


              state.count = data.count;
              state.pageCount = data.pages;
              state.filteredList = data.data;

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function requestFiltered(_x2, _x3) {
      return _ref6.apply(this, arguments);
    }

    return requestFiltered;
  }(),
  requestDetailed: function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, id) {
      var commit = _ref8.commit;

      var _ref10, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].get('/products/' + id);

            case 2:
              _ref10 = _context3.sent;
              data = _ref10.data;

              commit('add', data.data);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function requestDetailed(_x4, _x5) {
      return _ref9.apply(this, arguments);
    }

    return requestDetailed;
  }(),
  refreshStock: function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref11, id) {
      var commit = _ref11.commit;

      var _ref13, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].get('/products/' + id + '/stock');

            case 2:
              _ref13 = _context4.sent;
              data = _ref13.data;

              commit('refreshStock', data.data);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function refreshStock(_x6, _x7) {
      return _ref12.apply(this, arguments);
    }

    return refreshStock;
  }(),
  setFilterCategory: function setFilterCategory(_ref14, category) {
    var commit = _ref14.commit;

    commit('setFilterCategory', category);
  },
  setPage: function setPage(_ref15, page) {
    var commit = _ref15.commit;

    commit('setPage', page);
  }
};

/***/ }),
/* 133 */,
/* 134 */
/*!*********************************!*\
  !*** ./client/mixins/search.js ***!
  \*********************************/
/*! exports provided: default, searchByString */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchByString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_levenshtein__ = __webpack_require__(/*! fast-levenshtein */ 135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_levenshtein___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_levenshtein__);


var MAX_ALLOWED_DISTANCE = 3;

/* harmony default export */ __webpack_exports__["a"] = (function (searchString, fields) {
  return searchString.split(' ').reduce(function (carry, search) {
    return carry || searchByString(search, fields);
  }, false);
});

function searchByString(search, fields) {
  return fields.reduce(function (carry, field) {
    if (!search || !field) return false;
    var searchStr = search.toString().toLowerCase();
    var str = field.toString().toLowerCase();

    if (searchStr === '') return false;

    return carry || str.includes(searchStr) || __WEBPACK_IMPORTED_MODULE_0_fast_levenshtein___default.a.get(str, searchStr) <= MAX_ALLOWED_DISTANCE;
  }, false);
}

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/*!******************************!*\
  !*** ./client/store/shop.js ***!
  \******************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  shop: null,
  meta: {
    useRootContainer: true,
    isMobile: false,
    isEditor: false
  }
};

var getters = {
  get: function get(state) {
    if (!state.shop) return {};
    return state.shop;
  },
  getMetaIsMobile: function getMetaIsMobile(state) {
    return state.meta.isMobile;
  },
  getMetaIsEditor: function getMetaIsEditor(state) {
    return state.meta.isEditor;
  },
  getUseRootContainer: function getUseRootContainer(state) {
    return state.meta.useRootContainer;
  }
};

var mutations = {
  set: function set(state, shop) {
    state.shop = shop;
  },
  setMetaIsMobile: function setMetaIsMobile(state, isMobile) {
    state.meta.isMobile = isMobile;
  },
  setMetaIsEditor: function setMetaIsEditor(state, isEditor) {
    state.meta.isEditor = isEditor;
  },
  setUseRootContainer: function setUseRootContainer(state, useRootContainer) {
    state.meta.useRootContainer = useRootContainer;
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.shop) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shops');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              commit('set', data.data);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 180 */
/*!*****************************************!*\
  !*** ./client/store/shopInformation.js ***!
  \*****************************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 4);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  information: null
};

var getters = {
  get: function get(state) {
    if (!state.information) return {};
    return state.information;
  }
};

var mutations = {
  set: function set(state, information) {
    state.information = information;
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1615903335_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.information) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shops/informations');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              commit('set', data.data);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 181 */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672d7c5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localesLoaded)?_c('div',{class:{
    'wc_content_container_inner': _vm.useRootContainer && !_vm.isMobile,
    'wc_content_container_mobile': _vm.useRootContainer && _vm.isMobile
  },attrs:{"id":"wsc_shop_app"}},[_c('router-view',{attrs:{"name":_vm.mediaQueryDevice}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */,
/* 183 */
/*!********************************************!*\
  !*** ./client/router/guards/beforeEach.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This guard checks the url on each navigation and sets the corresponding navigation item as active.
 * Since we are not making a full page reload we can not use the php render function to set the active item.
 *
 * @param to
 * @param from
 * @param next
 */
/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  var elements = document.getElementsByClassName('navigationElement');
  Array.prototype.forEach.call(elements, function (el) {
    el.classList.remove('active');
  });

  var selector = '/shop';
  if (to.name === 'cart/index') {
    selector = '/shop#/cart';
  }

  elements = document.getElementsByClassName('navigationElement shop');
  Array.prototype.forEach.call(elements, function (el) {
    var node = el.querySelectorAll('[href$="' + selector + '"], [page_id="module_shop"]');
    if (node.length) {
      node[0].parentNode.classList.add('active');
    }
  });

  // in mobile view we need to close the navigation, because we do not always make a full page reload
  var mobileMenu = document.getElementsByClassName('wsc_navigation_close');
  if (mobileMenu.length) {
    mobileMenu[0].click();
  }

  // add a class to body
  document.body.classList.add('module-shop-active');

  next();
});

/***/ }),
/* 184 */
/*!*******************************************!*\
  !*** ./client/router/guards/afterEach.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(/*! ./../../store/index */ 7);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from) {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["default"].commit('shop/setUseRootContainer', true);
});

/***/ }),
/* 185 */
/*!*****************************************************!*\
  !*** ./client/router nonrecursive ^\.\/[^_].*\.js$ ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart.js": 186,
	"./checkout.js": 191,
	"./conditions.js": 192,
	"./index.js": 43,
	"./products.js": 193
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 185;

/***/ }),
/* 186 */
/*!*******************************!*\
  !*** ./client/router/cart.js ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 12);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/cart'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('cart/index'))]);

/***/ }),
/* 187 */
/*!********************************************!*\
  !*** ./client/views/desktop lazy ^\.\/.*$ ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart": [
		15,
		5
	],
	"./cart/": [
		15,
		5
	],
	"./cart/index": [
		15,
		5
	],
	"./cart/index.vue": [
		15,
		5
	],
	"./cart/index/cart-article": [
		60,
		26
	],
	"./cart/index/cart-article.vue": [
		60,
		26
	],
	"./checkout": [
		16,
		3
	],
	"./checkout/": [
		16,
		3
	],
	"./checkout/completed": [
		70,
		37
	],
	"./checkout/completed.vue": [
		70,
		37
	],
	"./checkout/index": [
		16,
		3
	],
	"./checkout/index.vue": [
		16,
		3
	],
	"./checkout/index/cart-article": [
		61,
		25
	],
	"./checkout/index/cart-article.vue": [
		61,
		25
	],
	"./checkout/shipping": [
		71,
		22
	],
	"./checkout/shipping.vue": [
		71,
		22
	],
	"./conditions/business": [
		72,
		32
	],
	"./conditions/business.vue": [
		72,
		32
	],
	"./conditions/cancellation": [
		73,
		30
	],
	"./conditions/cancellation.vue": [
		73,
		30
	],
	"./conditions/delivery": [
		74,
		28
	],
	"./conditions/delivery.vue": [
		74,
		28
	],
	"./products": [
		17,
		1
	],
	"./products/": [
		17,
		1
	],
	"./products/index": [
		17,
		1
	],
	"./products/index.vue": [
		17,
		1
	],
	"./products/index/listing-filter": [
		62,
		35
	],
	"./products/index/listing-filter.vue": [
		62,
		35
	],
	"./products/show": [
		75,
		6
	],
	"./products/show.vue": [
		75,
		6
	],
	"./products/show/view": [
		63,
		8
	],
	"./products/show/view.vue": [
		63,
		8
	],
	"./products/show/views/four": [
		55,
		13
	],
	"./products/show/views/four.vue": [
		55,
		13
	],
	"./products/show/views/one": [
		52,
		12
	],
	"./products/show/views/one.vue": [
		52,
		12
	],
	"./products/show/views/three": [
		54,
		11
	],
	"./products/show/views/three.vue": [
		54,
		11
	],
	"./products/show/views/two": [
		53,
		10
	],
	"./products/show/views/two.vue": [
		53,
		10
	],
	"./products/show/views/viewMixin": [
		50,
		17
	],
	"./products/show/views/viewMixin.js": [
		50,
		17
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 187;
module.exports = webpackAsyncContext;

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */
/*!*******************************************!*\
  !*** ./client/views/mobile lazy ^\.\/.*$ ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart": [
		18,
		4
	],
	"./cart/": [
		18,
		4
	],
	"./cart/index": [
		18,
		4
	],
	"./cart/index.vue": [
		18,
		4
	],
	"./cart/index/cart-article": [
		64,
		24
	],
	"./cart/index/cart-article.vue": [
		64,
		24
	],
	"./checkout": [
		19,
		2
	],
	"./checkout/": [
		19,
		2
	],
	"./checkout/completed": [
		76,
		36
	],
	"./checkout/completed.vue": [
		76,
		36
	],
	"./checkout/index": [
		19,
		2
	],
	"./checkout/index.vue": [
		19,
		2
	],
	"./checkout/index/cart-article": [
		65,
		23
	],
	"./checkout/index/cart-article.vue": [
		65,
		23
	],
	"./checkout/shipping": [
		77,
		21
	],
	"./checkout/shipping.vue": [
		77,
		21
	],
	"./conditions/business": [
		78,
		31
	],
	"./conditions/business.vue": [
		78,
		31
	],
	"./conditions/cancellation": [
		79,
		29
	],
	"./conditions/cancellation.vue": [
		79,
		29
	],
	"./conditions/delivery": [
		80,
		27
	],
	"./conditions/delivery.vue": [
		80,
		27
	],
	"./products": [
		20,
		0
	],
	"./products/": [
		20,
		0
	],
	"./products/index": [
		20,
		0
	],
	"./products/index.vue": [
		20,
		0
	],
	"./products/index/listing-filter": [
		66,
		34
	],
	"./products/index/listing-filter.vue": [
		66,
		34
	],
	"./products/show": [
		81,
		7
	],
	"./products/show.vue": [
		81,
		7
	],
	"./products/show/view": [
		67,
		9
	],
	"./products/show/view.vue": [
		67,
		9
	],
	"./products/show/views/four": [
		59,
		18
	],
	"./products/show/views/four.vue": [
		59,
		18
	],
	"./products/show/views/one": [
		56,
		16
	],
	"./products/show/views/one.vue": [
		56,
		16
	],
	"./products/show/views/three": [
		58,
		15
	],
	"./products/show/views/three.vue": [
		58,
		15
	],
	"./products/show/views/two": [
		57,
		14
	],
	"./products/show/views/two.vue": [
		57,
		14
	],
	"./products/show/views/viewMixin": [
		51,
		19
	],
	"./products/show/views/viewMixin.js": [
		51,
		19
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 190;
module.exports = webpackAsyncContext;

/***/ }),
/* 191 */
/*!***********************************!*\
  !*** ./client/router/checkout.js ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 12);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/checkout'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/index')), Object.assign({
  path: '/checkout/shipping'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/shipping')), Object.assign({
  path: '/checkout/checkout'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/checkout')), Object.assign({
  path: '/checkout/completed'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/completed')), {
  path: '/checkout/twint',
  name: 'checkout/twintPayment',
  components: {
    desktop: function desktop() {
      return __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, /*! ../views/common/checkout/twintPayment */ 82));
    },
    mobile: function mobile() {
      return __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, /*! ../views/common/checkout/twintPayment */ 82));
    }
  }
}, {
  path: '/checkout/stripe',
  name: 'checkout/stripePayment',
  components: {
    desktop: function desktop() {
      return __webpack_require__.e/* import() */(33/* duplicate */).then(__webpack_require__.bind(null, /*! ../views/common/checkout/stripePayment */ 83));
    },
    mobile: function mobile() {
      return __webpack_require__.e/* import() */(33/* duplicate */).then(__webpack_require__.bind(null, /*! ../views/common/checkout/stripePayment */ 83));
    }
  }
}]);

/***/ }),
/* 192 */
/*!*************************************!*\
  !*** ./client/router/conditions.js ***!
  \*************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 12);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/terms-and-conditions/business'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('conditions/business')), Object.assign({
  path: '/terms-and-conditions/cancellation'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('conditions/cancellation')), Object.assign({
  path: '/terms-and-conditions/delivery'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('conditions/delivery'))]);

/***/ }),
/* 193 */
/*!***********************************!*\
  !*** ./client/router/products.js ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 12);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/products'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('products/index')), Object.assign({
  path: '/products/category/:category'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('products/index')), Object.assign({
  path: '/products/:id'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('products/show'))]);

/***/ }),
/* 194 */
/*!*********************************!*\
  !*** ./client/plugins/index.js ***!
  \*********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(/*! ./axios */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uiv__ = __webpack_require__(/*! ./uiv */ 195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_components__ = __webpack_require__(/*! ./ui-components */ 197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_i18n__ = __webpack_require__(/*! ./vue-i18n */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_paginate__ = __webpack_require__(/*! ./vue-paginate */ 213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wsc_shop__ = __webpack_require__(/*! ./wsc-shop */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wsc_locales__ = __webpack_require__(/*! ./wsc-locales */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wsc_translatable__ = __webpack_require__(/*! ./wsc-translatable */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(/*! lodash/get */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);











function registerHelpers() {
  // register locales
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$usedLocale = __WEBPACK_IMPORTED_MODULE_7__wsc_locales__["b" /* default */].usedLocale;
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$defaultLocale = __WEBPACK_IMPORTED_MODULE_7__wsc_locales__["b" /* default */].defaultLocale;

  // register translatable
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$translatable = function (model, prop) {
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    // if no other locale is provided
    var storeLocale = __WEBPACK_IMPORTED_MODULE_7__wsc_locales__["b" /* default */].usedLocale;
    return Object(__WEBPACK_IMPORTED_MODULE_8__wsc_translatable__["b" /* translatableOrDefault */])(model, prop, locale || storeLocale);
  };

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$translatableNoDefault = function (model, prop) {
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    var storeLocale = __WEBPACK_IMPORTED_MODULE_7__wsc_locales__["b" /* default */].usedLocale;
    return Object(__WEBPACK_IMPORTED_MODULE_8__wsc_translatable__["a" /* translatable */])(model, prop, locale || storeLocale);
  };

  // register lodash get helper
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$_get = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default.a;
}

registerHelpers();

/***/ }),
/* 195 */
/*!*******************************!*\
  !*** ./client/plugins/uiv.js ***!
  \*******************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uiv__ = __webpack_require__(/*! uiv */ 196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uiv__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tooltip', __WEBPACK_IMPORTED_MODULE_1_uiv__["Tooltip"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('carousel', __WEBPACK_IMPORTED_MODULE_1_uiv__["Carousel"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('slide', __WEBPACK_IMPORTED_MODULE_1_uiv__["Slide"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('collapse', __WEBPACK_IMPORTED_MODULE_1_uiv__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('dropdown', __WEBPACK_IMPORTED_MODULE_1_uiv__["Dropdown"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_1_uiv__["Modal"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tab', __WEBPACK_IMPORTED_MODULE_1_uiv__["Tab"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tabs', __WEBPACK_IMPORTED_MODULE_1_uiv__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datePicker', __WEBPACK_IMPORTED_MODULE_1_uiv__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('alert', __WEBPACK_IMPORTED_MODULE_1_uiv__["Alert"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('pagination', __WEBPACK_IMPORTED_MODULE_1_uiv__["Pagination"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('popover', __WEBPACK_IMPORTED_MODULE_1_uiv__["Popover"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('timePicker', __WEBPACK_IMPORTED_MODULE_1_uiv__["TimePicker"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('typeahead', __WEBPACK_IMPORTED_MODULE_1_uiv__["Typeahead"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('progressBar', __WEBPACK_IMPORTED_MODULE_1_uiv__["ProgressBar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('progressBarStack', __WEBPACK_IMPORTED_MODULE_1_uiv__["ProgressBarStack"]);

/***/ }),
/* 196 */,
/* 197 */
/*!*****************************************!*\
  !*** ./client/plugins/ui-components.js ***!
  \*****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ui_slider__ = __webpack_require__(/*! components/ui/slider */ 198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ui_loading__ = __webpack_require__(/*! components/ui/loading */ 201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ui_multiselect__ = __webpack_require__(/*! components/ui/multiselect */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ui_singleselect__ = __webpack_require__(/*! components/ui/singleselect */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ui_productPanel__ = __webpack_require__(/*! components/ui/productPanel */ 211);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-multiselect', __WEBPACK_IMPORTED_MODULE_3_components_ui_multiselect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-singleselect', __WEBPACK_IMPORTED_MODULE_4_components_ui_singleselect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-slider', __WEBPACK_IMPORTED_MODULE_1_components_ui_slider__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-loading', __WEBPACK_IMPORTED_MODULE_2_components_ui_loading__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('product-panel', __WEBPACK_IMPORTED_MODULE_5_components_ui_productPanel__["a" /* default */]);

/***/ }),
/* 198 */
/*!*****************************************!*\
  !*** ./client/components/ui/slider.vue ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./slider.vue */ 44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2516a92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c2516a92","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./slider.vue */ 200);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c2516a92","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./slider.vue */ 199)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2516a92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 199 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2516a92","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/slider.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2516a92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/slider.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-checkbox"},[_c('div',{staticClass:"switch--switch"},[_c('label',{attrs:{"for":_vm.id}},[_c('input',{class:_vm.className,attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.updateInput}}),_vm._v(" "),_c('div',{staticClass:"slider round"})])]),_vm._v(" "),_c('div',{staticClass:"switch--label",domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":_vm.toggleChecked}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/*!******************************************!*\
  !*** ./client/components/ui/loading.vue ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./loading.vue */ 45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0efe1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5f0efe1e","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./loading.vue */ 203);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5f0efe1e","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./loading.vue */ 202)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0efe1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f0efe1e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/loading.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0efe1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/loading.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"wsc_loader--inline"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',{staticClass:"loader-label"},[_vm._v(_vm._s(_vm.$t('general.loading')))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/*!**********************************************!*\
  !*** ./client/components/ui/multiselect.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multiselect_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./multiselect.vue */ 46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4fe7d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ab4fe7d8","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./multiselect.vue */ 207);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ab4fe7d8","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./multiselect.vue */ 205)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multiselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4fe7d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab4fe7d8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/multiselect.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */,
/* 207 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab4fe7d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/multiselect.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{staticClass:"ui-multiselect",attrs:{"value":_vm.value,"label":_vm.label,"custom-label":_vm.customLabel,"track-by":_vm.trackBy,"options":_vm.options,"multiple":_vm.multiple,"taggable":_vm.taggable,"allow-empty":_vm.allowEmpty,"close-on-select":_vm.closeOnSelect,"clear-on-select":_vm.clearOnSelect,"disabled":_vm.disabled,"placeholder":_vm.placeholderText,"tag-placeholder":"","select-label":"","selected-label":"","deselect-label":""},on:{"tag":_vm.tag,"input":_vm.input}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('modules.shop.messages.filter-no-result')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/*!***********************************************!*\
  !*** ./client/components/ui/singleselect.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleselect_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./singleselect.vue */ 47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dcacbe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleselect_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-61dcacbe","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./singleselect.vue */ 210);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-61dcacbe","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./singleselect.vue */ 209)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61dcacbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dcacbe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61dcacbe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/singleselect.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dcacbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/singleselect.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.classes,attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":_vm.valueChanged}},[(_vm.placeholder)?_c('option',{attrs:{"disabled":""},domProps:{"value":undefined}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/*!***********************************************!*\
  !*** ./client/components/ui/productPanel.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productPanel_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./productPanel.vue */ 48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d32c2f1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productPanel_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3d32c2f1","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./productPanel.vue */ 212);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d32c2f1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d32c2f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/productPanel.vue ***!
  \************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'product--show-panel': _vm.usePanels, 'product--hide-panel': !_vm.usePanels}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 213 */
/*!****************************************!*\
  !*** ./client/plugins/vue-paginate.js ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_paginate__ = __webpack_require__(/*! vue-paginate */ 214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_paginate__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_paginate___default.a);

/***/ }),
/* 214 */,
/* 215 */
/*!********************************!*\
  !*** ./assets/scss/style.scss ***!
  \********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[84]);


// WEBPACK FOOTER //
// client.3e7386ed.js